import { render, staticRenderFns } from "./ConversationMessageParent.vue?vue&type=template&id=9028a3fa&scoped=true"
import script from "./ConversationMessageParent.vue?vue&type=script&lang=js"
export * from "./ConversationMessageParent.vue?vue&type=script&lang=js"
import style0 from "./ConversationMessageParent.vue?vue&type=style&index=0&id=9028a3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028a3fa",
  null
  
)

export default component.exports